import { BASE_API_URL } from 'src/constants/services';

/* eslint-disable no-unused-vars */
export const API_URL = `${BASE_API_URL}`;

export enum ApiPath {
  LOGIN = '/api/login',
  USER = '/api/v1/admin/users',
  COMPANY = '/api/companies',
  UPLOAD_FILE = '/api/upload-file',
  PROFILE = '/api/profile',
  CHANGE_PASSWORD = '/api/change-password',
  COMPANY_REGISTRATION = '/api/company-registrations',
  SYSTEM_ADMINS = '/api/system-admins',
  COMPANY_ADMINS = '/api/company-admins',
  COMPANY_STAFFS = '/api/company-staffs',
  SCAN_HISTORIES = '/api/scan-histories',
  PRODUCT = '/api/products',
  REPORT = '/api/reports',
  STICKER = '/api/product-sticker-orders',
  RENEWAL = '/api/company-licence-renewal-orders',
  ANALYTIC = '/api/analytics/company-registrations',
  FORGOT_PASSWORD = '/api/forgot-password',
  RESET_PASSWORD = '/api/reset-password',
  VALUE_CHAIN_TYPE = '/api/value-chain-type',
  SYSTEM_ADMIN = '/api/system-admins',
  PERMISSION = '/api/permissions',
  SETTING = '/api/settings'
}
